export const footerLinks = {
    'kg-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://kg.wingie.com/flights/to-bishkek/',
                    title: 'Бишкек',
                },
                {
                    href: 'https://kg.wingie.com/flights/to-osh/',
                    title: 'Ош',
                },
                {
                    href: 'https://kg.wingie.com/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://kg.wingie.com/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kg.wingie.com/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kg.wingie.com/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://kg.wingie.com/flights/ru-russia/',
                    title: 'Россия',
                },
                {
                    href: 'https://kg.wingie.com/flights/tr-turkey/',
                    title: 'Турция',
                },
                {
                    href: 'https://kg.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'ОАЭ',
                },
                {
                    href: 'https://kg.wingie.com/flights/kz-kazakhstan/',
                    title: 'Казахстан',
                },
                {
                    href: 'https://kg.wingie.com/flights/cn-china/',
                    title: 'Китай',
                },
                {
                    href: 'https://kg.wingie.com/flights/kr-south-korea/',
                    title: 'Южная Корея',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://kg.wingie.com/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kg.wingie.com/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://kg.wingie.com/en/flights/to-bishkek/',
                    title: 'Bishkek',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/to-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/to-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://kg.wingie.com/en/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/tr-turkey/',
                    title: 'Turkey',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'UAE',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/kz-kazakhstan/',
                    title: 'Kazakhstan',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/kr-south-korea/',
                    title: 'South Korea',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/en/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-es': [
        {
            title: 'Destinos principales',
            items: [
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-bishkek/',
                    title: 'Biskek',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-moscu/',
                    title: 'Moscú',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubái',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://kg.wingie.com/es/vuelos/ru-rusia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/tr-turquia/',
                    title: 'Turquía',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
                    title: 'Emiratos Árabes Unidos',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/kz-kazajistan/',
                    title: 'Kazajistán',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/kr-corea-del-sur/',
                    title: 'Corea del Sur',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/es/vuelos/companias-aereas/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-de': [
        {
            title: 'Top-Reiseziele',
            items: [
                {
                    href: 'https://kg.wingie.com/de/flug/nach-bischkek/',
                    title: 'Bischkek',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/nach-osch/',
                    title: 'Osch',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/nach-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/nach-moskau/',
                    title: 'Moskau',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://kg.wingie.com/de/flug/ru-russland/',
                    title: 'Russland',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/tr-turkei/',
                    title: 'Türkei',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/ae-vereinigte-arabische-emirate/',
                    title: 'Vereinigte Arabische Emirate',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/kz-kasachstan/',
                    title: 'Kasachstan',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/kr-sudkorea/',
                    title: 'Südkorea',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/de/flug/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://kg.wingie.com/ar/flights/to-bishkek/',
                    title: 'بيشكيك',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/to-osh/',
                    title: 'أوش',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/to-tashkent/',
                    title: 'طشقند',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/to-moscow/',
                    title: 'موسكو',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/to-istanbul/',
                    title: 'إسطنبول',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/to-dubai/',
                    title: 'دبي',
                },
            ],
        },
        {
            title: 'الدول الشعبية',
            items: [
                {
                    href: 'https://kg.wingie.com/ar/flights/ru-russia/',
                    title: 'روسيا',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/kz-kazakhstan/',
                    title: 'كازاخستان',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/cn-china/',
                    title: 'الصين',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/kr-south-korea/',
                    title: 'كوريا الجنوبية',
                },
            ],
        },
        {
            title: 'شركات الطيران الشعبية',
            items: [
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/air-manas/',
                    title: 'إير ماناس',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/avia-traffic-company/',
                    title: 'شركة أفيا ترافيك',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/air-kyrgyzstan/',
                    title: 'الخطوط الجوية القرغيزية',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/aeroflot/',
                    title: 'أيروفلوت',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://kg.wingie.com/ar/flights/airlines/fly-dubai/',
                    title: 'فلاي دبي',
                },
            ],
        },
    ],
    'kg-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://kg.wingie.com/it/flights/to-bishkek/',
                    title: 'Bishkek',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/to-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/to-moscow/',
                    title: 'Mosca',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://kg.wingie.com/it/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/tr-turkey/',
                    title: 'Turchia',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/ae-united-arab-emirates/',
                    title: 'Emirati Arabi Uniti',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/kz-kazakhstan/',
                    title: 'Kazakistan',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/cn-china/',
                    title: 'Cina',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/kr-south-korea/',
                    title: 'Corea del Sud',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/it/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://kg.wingie.com/fr/flights/to-bishkek/',
                    title: 'Bichkek',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/to-osh/',
                    title: 'Och',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/to-moscow/',
                    title: 'Moscou',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/to-dubai/',
                    title: 'Dubaï',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://kg.wingie.com/fr/flights/ru-russia/',
                    title: 'Russie',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/tr-turkey/',
                    title: 'Turquie',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/ae-united-arab-emirates/',
                    title: 'Émirats Arabes Unis',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/kz-kazakhstan/',
                    title: 'Kazakhstan',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/cn-china/',
                    title: 'Chine',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/kr-south-korea/',
                    title: 'Corée du Sud',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/fr/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://kg.wingie.com/pt/flights/to-bishkek/',
                    title: 'Bishkek',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/to-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/to-moscow/',
                    title: 'Moscovo',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/to-istanbul/',
                    title: 'Istambul',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://kg.wingie.com/pt/flights/ru-russia/',
                    title: 'Rússia',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/tr-turkey/',
                    title: 'Turquia',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/ae-united-arab-emirates/',
                    title: 'Emirados Árabes Unidos',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/kz-kazakhstan/',
                    title: 'Cazaquistão',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/kr-south-korea/',
                    title: 'Coreia do Sul',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/pt/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://kg.wingie.com/ro/flights/to-bishkek/',
                    title: 'Bișkek',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/to-osh/',
                    title: 'Oș',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/to-moscow/',
                    title: 'Moscova',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://kg.wingie.com/ro/flights/ru-russia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/tr-turkey/',
                    title: 'Turcia',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/ae-united-arab-emirates/',
                    title: 'Emiratele Arabe Unite',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/kz-kazakhstan/',
                    title: 'Kazahstan',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/kr-south-korea/',
                    title: 'Coreea de Sud',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/ro/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://kg.wingie.com/pl/flights/to-bishkek/',
                    title: 'Biszkek',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/to-osh/',
                    title: 'Osz',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/to-moscow/',
                    title: 'Moskwa',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/to-istanbul/',
                    title: 'Stambuł',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/to-dubai/',
                    title: 'Dubaj',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://kg.wingie.com/pl/flights/ru-russia/',
                    title: 'Rosja',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/tr-turkey/',
                    title: 'Turcja',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/ae-united-arab-emirates/',
                    title: 'Zjednoczone Emiraty Arabskie',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/kz-kazakhstan/',
                    title: 'Kazachstan',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/cn-china/',
                    title: 'Chiny',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/kr-south-korea/',
                    title: 'Korea Południowa',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/pl/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://kg.wingie.com/lt/flights/to-bishkek/',
                    title: 'Biškekas',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/to-osh/',
                    title: 'Ošas',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/to-moscow/',
                    title: 'Maskva',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/to-istanbul/',
                    title: 'Stambulas',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/to-dubai/',
                    title: 'Dubajus',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://kg.wingie.com/lt/flights/ru-russia/',
                    title: 'Rusija',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/tr-turkey/',
                    title: 'Turkija',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/ae-united-arab-emirates/',
                    title: 'Jungtiniai Arabų Emyratai',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/kz-kazakhstan/',
                    title: 'Kazachstanas',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/cn-china/',
                    title: 'Kinija',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/kr-south-korea/',
                    title: 'Pietų Korėja',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/lt/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://kg.wingie.com/uz/flights/to-bishkek/',
                    title: 'Bishkek',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/to-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/to-moscow/',
                    title: 'Moskva',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/to-dubai/',
                    title: 'Dubay',
                },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                {
                    href: 'https://kg.wingie.com/uz/flights/ru-russia/',
                    title: 'Rossiya',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/tr-turkey/',
                    title: 'Turkiya',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/ae-united-arab-emirates/',
                    title: 'BAA',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/kz-kazakhstan/',
                    title: 'Qozogiston',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/cn-china/',
                    title: 'Xitoy',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/kr-south-korea/',
                    title: 'Janubiy Koreya',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/uz/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-sr': [
        {
            title: 'Најпопуларније дестинације',
            items: [
                {
                    href: 'https://kg.wingie.com/sr/flights/to-bishkek/',
                    title: 'Бишкек',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/to-osh/',
                    title: 'Ош',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/to-dubai/',
                    title: 'Дубаи',
                },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                {
                    href: 'https://kg.wingie.com/sr/flights/ru-russia/',
                    title: 'Русија',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/tr-turkey/',
                    title: 'Турска',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/ae-united-arab-emirates/',
                    title: 'УАЕ',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/kz-kazakhstan/',
                    title: 'Казахстан',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/cn-china/',
                    title: 'Кина',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/kr-south-korea/',
                    title: 'Јужна Кореја',
                },
            ],
        },
        {
            title: 'Популарне авиокомпаније',
            items: [
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/aeroflot/',
                    title: 'Аерофлот',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/sr/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://kg.wingie.com/ky/flights/to-bishkek/',
                    title: 'Бишкек',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/to-osh/',
                    title: 'Ош',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://kg.wingie.com/ky/flights/ru-russia/',
                    title: 'Орусия',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/ae-united-arab-emirates/',
                    title: 'БАЭ',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/kz-kazakhstan/',
                    title: 'Казакстан',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/cn-china/',
                    title: 'Кытай',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/kr-south-korea/',
                    title: 'Түштүк Корея',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/ky/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-tg': [
        {
            title: 'Шаҳрҳои машҳур',
            items: [
                {
                    href: 'https://kg.wingie.com/tg/flights/to-bishkek/',
                    title: 'Бишкек',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/to-osh/',
                    title: 'Ош',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/to-moscow/',
                    title: 'Маскав',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                {
                    href: 'https://kg.wingie.com/tg/flights/ru-russia/',
                    title: 'Русия',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/tr-turkey/',
                    title: 'Туркия',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/ae-united-arab-emirates/',
                    title: 'ИАМ',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/kz-kazakhstan/',
                    title: 'Қазоқистон',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/cn-china/',
                    title: 'Чин',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/kr-south-korea/',
                    title: 'Кореяи Ҷанубӣ',
                },
            ],
        },
        {
            title: 'Ширкатҳои машҳури авиатсионӣ',
            items: [
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/tg/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                {
                    href: 'https://kg.wingie.com/kk/flights/to-bishkek/',
                    title: 'Бішкек',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/to-osh/',
                    title: 'Ош',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/to-tashkent/',
                    title: 'Ташкент',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/to-moscow/',
                    title: 'Мәскеу',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://kg.wingie.com/kk/flights/ru-russia/',
                    title: 'Ресей',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/ae-united-arab-emirates/',
                    title: 'БАӘ',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/kz-kazakhstan/',
                    title: 'Қазақстан',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/cn-china/',
                    title: 'Қытай',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/kr-south-korea/',
                    title: 'Оңтүстік Корея',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/kk/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://kg.wingie.com/nl/flights/to-bishkek/',
                    title: 'Bishkek',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/to-osh/',
                    title: 'Osh',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/to-tashkent/',
                    title: 'Tashkent',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/to-moscow/',
                    title: 'Moskou',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://kg.wingie.com/nl/flights/ru-russia/',
                    title: 'Rusland',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/tr-turkey/',
                    title: 'Turkije',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/ae-united-arab-emirates/',
                    title: 'VAE',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/kz-kazakhstan/',
                    title: 'Kazachstan',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/kr-south-korea/',
                    title: 'Zuid-Korea',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/air-manas/',
                    title: 'Air Manas',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/avia-traffic-company/',
                    title: 'Avia Traffic Company',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/air-kyrgyzstan/',
                    title: 'Air Kyrgyzstan',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kg.wingie.com/nl/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kg-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://kg.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://kg.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://kg.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://kg.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://kg.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://kg.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://kg.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://kg.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://kg.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://kg.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://kg.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://kg.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://kg.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://kg.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://kg.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://kg.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://kg.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://kg.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://kg.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://kg.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://kg.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://kg.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://kg.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://kg.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://kg.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://kg.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://kg.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://kg.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://kg.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://kg.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://kg.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://kg.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://kg.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://kg.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://kg.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://kg.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://kg.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://kg.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://kg.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://kg.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://kg.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://kg.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://kg.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://kg.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://kg.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://kg.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://kg.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://kg.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://kg.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://kg.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://kg.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://kg.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://kg.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://kg.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://kg.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://kg.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://kg.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://kg.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://kg.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://kg.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://kg.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://kg.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://kg.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://kg.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://kg.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://kg.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://kg.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://kg.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://kg.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://kg.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://kg.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://kg.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://kg.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://kg.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://kg.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://kg.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://kg.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://kg.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://kg.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://kg.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://kg.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://kg.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://kg.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://kg.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://kg.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://kg.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://kg.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://kg.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://kg.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://kg.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://kg.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://kg.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://kg.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://kg.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://kg.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://kg.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://kg.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://kg.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://kg.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://kg.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://kg.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://kg.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://kg.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://kg.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://kg.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://kg.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://kg.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://kg.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://kg.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://kg.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://kg.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://kg.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://kg.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://kg.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://kg.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://kg.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://kg.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://kg.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://kg.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kg-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://kg.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://kg.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://kg.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://kg.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://kg.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://kg.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://kg.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://kg.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://kg.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://kg.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://kg.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://kg.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://kg.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://kg.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://kg.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://kg.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kg.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://kg.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}